import { FC } from 'react'
import { Box } from '@mui/material'
import SiteHeader from '../siteHeader.component'
import { useTranslation } from 'react-i18next'
import ContactsPage from './contacts.page'

const SiteContacts: FC = () => {
    const { t } = useTranslation('site')
    return (
        <Box>
            <SiteHeader title={t('navLinks.contacts')} />
            <ContactsPage />
        </Box>
    )
}

export default SiteContacts
